// Smooth-scroll a page section into view, landing just below whatever sticks above the content
// (pass the sticky header's height as `offset`). With `flash`, the target briefly shows a
// highlight ring so the jump is visible even when the section was already on screen.
// Returns false when the element isn't on the page.
const FLASH_CLASSES = ['ring-2', 'ring-amber-400', 'ring-offset-2', 'ring-offset-gray-50', 'dark:ring-offset-gray-900', 'rounded-lg', 'transition-shadow'];

export function scrollToSection(id: string, offset = 0, opts: { flash?: boolean } = {}): boolean {
  const el = document.getElementById(id);
  if (!el) return false;
  const top = el.getBoundingClientRect().top + window.scrollY - offset - 16;
  window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  if (opts.flash) {
    el.classList.add(...FLASH_CLASSES);
    window.setTimeout(() => el.classList.remove(...FLASH_CLASSES), 1500);
  }
  return true;
}
